'use client'

import getLocale from '@/stores/locales'
import { device } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { Button, Col, Row, Tag } from 'antd'
import { IFilterTag, IParamsByUrl, ISelectedFilters } from '~types/search'
import buildTagsForSelectedFilters from '../useCases/buildTagsForSelectedFilters'

import goToSearchV2 from '@/navigation/CSR/goToSearchV2/goToSearch'
import { useRouter } from 'next/navigation'
import useWindowMobile from '../useCases/useWindowMobile'
import './tagStyle.css'

const fallbackCurrencyFormat = {
  style: 'currency',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  currency: 'USD',
}

const fallbackCurrencyLocale = 'en-US'

const AppliedFiltersRow = (props: {
  numberOfFiltersApplied: number
  appliedFilters: ISelectedFilters
  clientConfig: ClientModel
  userAgent?: string
  urlParams: IParamsByUrl
}) => {
  const router = useRouter()
  const isScreenMobile = useWindowMobile()
  const isMobile = device(props.userAgent).isMobile()

  if (isMobile || isScreenMobile) {
    return null
  }

  const copy = getLocale()

  const tags = buildTagsForSelectedFilters(
    props.appliedFilters,
    copy?.filter || {},
    {
      currencyFormat:
        props?.clientConfig?.currencyFormat || fallbackCurrencyFormat,
      currencyLocale:
        props?.clientConfig?.currencyLocale || fallbackCurrencyLocale,
    }
  )

  const onClose = async (tag: IFilterTag) => {
    console.log('🚀 ~ onClose ~ tag:', tag)
    await goToSearchV2({
      router,
      urlParams: props.urlParams,
      action: 'removeFilter',
      filterValue: tag.key,
      type: tag.type,
    })
  }

  const onClearTags = async () => {
    await goToSearchV2({
      router,
      urlParams: props.urlParams,
      action: 'clearAll',
    })
  }

  if (props.numberOfFiltersApplied === 0) return null

  return (
    <Row style={{ marginBottom: 16 }}>
      <Col span={24}>
        <Row align="middle">
          <Col span={3}>
            <h4>
              <span>({props.numberOfFiltersApplied})</span>{' '}
              {copy?.filter?.summaryTitle}
            </h4>
          </Col>
          <Col span={21}>
            {tags.map((tag) => (
              <Tag
                className="applied-filter-tag"
                bordered={false}
                key={tag.key}
                closable
                onClose={() => onClose(tag)}
              >
                {tag.label}
              </Tag>
            ))}
            <Button
              className="clear-button"
              onClick={onClearTags}
              color="primary"
              variant="outlined"
            >
              {copy?.filter?.clear}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default AppliedFiltersRow
